import {getYoutubeVideoUrl} from '@cohort/shared/apps/youtube/common';
import type {YoutubeLikeTriggerStruct} from '@cohort/shared/apps/youtube/triggers/like';
import type {ActionCtaComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import OpenCtaWithRefresh from '@cohort/wallet/components/challenges/OpenCtaWithRefresh';
import {useTranslation} from 'react-i18next';

const YoutubeLikeTriggerActionCtaComponent: React.FC<
  ActionCtaComponentProps<YoutubeLikeTriggerStruct>
> = ({config, trackingMetadata, stepId, processStepVerification}) => {
  const {t} = useTranslation('app-youtube', {
    keyPrefix: 'triggerIntegrations.like',
  });

  return (
    <OpenCtaWithRefresh
      url={getYoutubeVideoUrl(config.videoId)}
      stepId={stepId}
      processStepVerification={processStepVerification}
      trackingMetadata={trackingMetadata}
      ctaTitle={t('ctaTitle')}
      refreshCtaTitle={t('refreshTitle')}
    />
  );
};

export default YoutubeLikeTriggerActionCtaComponent;
